module.exports = __webpack_public_path__ + "static/moped-31d328b82ab86198c80818bdd2b92849.jpg";